
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import AnalyticsNotesTemplate from '../components/analytics-notes/AnalyticsNotesTemplate.vue';
  import { TAnalyticsNotesFilter } from '../types/analytics-notes';
  import { CostTypes, TreeCountryValues } from '../types/common-aggregated';
  import { TAggregatedPermissions } from '../types/permission';

  export default defineComponent({
    name: 'AnalyticsNotesYearly',
    components: { AnalyticsNotesTemplate },
    mixins: [security],
    data(): { defaultFilter: TAnalyticsNotesFilter; pageTitle: string } {
      return {
        defaultFilter: {
          periods: ['2011', '2012'],
          country: [TreeCountryValues.GERMANY_99],
          costType: CostTypes.BILLIONS_OF_DOLLARS,
        },
        pageTitle: 'Аналитическая записка по внешней торговле РФ по странам мира (годовая)',
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.getPermissions.view);
    },
    computed: {
      getPermissions(): TAggregatedPermissions {
        return {
          view: constants.Permissions.ForeignTradeAnalyticsRussiaWorldYearlyNoteView,
          build: constants.Permissions.ForeignTradeAnalyticsRussiaWorldYearlyNoteBuild,
          export: constants.Permissions.ForeignTradeAnalyticsRussiaWorldYearlyNoteDownload,
        };
      },
    },
  });
